import { api } from './api.util';

const BASE_URL = '/home-carousel';

export const getAllHomeCarouselItems = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.active !== undefined) {
      queryParams.append('active', params.active.toString());
    }

    if (params.itemType) {
      queryParams.append('itemType', params.itemType);
    }

    const url = queryParams.toString() ? `${BASE_URL}?${queryParams}` : BASE_URL;
    return await api.get(url);
  } catch (error) {
    console.error('Error fetching home carousel items:', error);
    throw error;
  }
};

export const getHomeCarouselItemById = async (id) => {
  try {
    return await api.get(`${BASE_URL}/${id}`);
  } catch (error) {
    console.error(`Error fetching home carousel item ${id}:`, error);
    throw error;
  }
};

export const createHomeCarouselItem = async (data) => {
  try {
    return await api.post(BASE_URL, data);
  } catch (error) {
    console.error('Error creating home carousel item:', error);
    throw error;
  }
};

export const updateHomeCarouselItem = async (id, data) => {
  try {
    return await api.put(`${BASE_URL}/${id}`, data);
  } catch (error) {
    console.error(`Error updating home carousel item ${id}:`, error);
    throw error;
  }
};

export const uploadHomeCarouselImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    return await api.upload(`${BASE_URL}/upload-image`, formData);
  } catch (error) {
    console.error('Error uploading home carousel image:', error);
    throw error;
  }
};

export const deleteHomeCarouselItem = async (id) => {
  try {
    return await api.delete(`${BASE_URL}/${id}`);
  } catch (error) {
    console.error(`Error deleting home carousel item ${id}:`, error);
    throw error;
  }
};
